import styles from './styles.module.scss';

import cn from 'classnames';

const TooltipBase = ({ style, text, className, position = '' }) => (
  <div
    className={cn(
      styles.tooltip,
      position === 'right' && styles.tooltip_right,
      position === 'bottom' && styles.tooltip_bottom,
      className,
    )}
    style={style}
  >
    {text}
  </div>
);

export default TooltipBase;
